<template>
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.3204 15.7535C1.3204 16.4524 1.90292 17.0002 2.62137 17.0002H11.3787C12.0971 17.0002 12.6796 16.4524 12.6796 15.7535L13.1845 5.47803H0.834961L1.3204 15.7535ZM9.3204 7.5369C9.3204 7.17802 9.53399 6.89469 9.90292 6.89469C10.2719 6.89469 10.4854 7.17802 10.4854 7.5369V14.6391C10.4854 14.998 10.2719 15.2813 9.90292 15.2813C9.53399 15.2813 9.3204 14.998 9.3204 14.6391V7.5369ZM6.40778 7.5369C6.40778 7.17802 6.62137 6.89469 6.9903 6.89469C7.35923 6.89469 7.57283 7.17802 7.57283 7.5369V14.6391C7.57283 14.998 7.35923 15.2813 6.9903 15.2813C6.62137 15.2813 6.40778 14.998 6.40778 14.6391V7.5369ZM3.49516 7.5369C3.49516 7.17802 3.70875 6.89469 4.07768 6.89469C4.44661 6.89469 4.6602 7.17802 4.6602 7.5369V14.6391C4.6602 14.998 4.44661 15.2813 4.07768 15.2813C3.70875 15.2813 3.49516 14.998 3.49516 14.6391V7.5369Z"
      fill="#6E6259"
    />
    <path
      d="M13.4175 2.26665H9.90291V0.585552C9.90291 0.245554 9.72816 0 9.35922 0H4.66019C4.29126 0 4.07767 0.245554 4.07767 0.585552V2.26665H0.601942C0.23301 2.26665 0 2.5311 0 2.88998V3.60776C0 3.96664 0.23301 4.34442 0.601942 4.34442H13.4369C13.8058 4.34442 14 3.94775 14 3.60776V2.88998C13.9806 2.5311 13.7864 2.26665 13.4175 2.26665ZM8.73786 2.26665H5.24272V1.13333H8.73786V2.26665Z"
      fill="#6E6259"
    />
  </svg>
</template>

<script>
export default { name: "svg-trash" };
</script>
